import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import banks from './banks.json';

export interface IBank {
	ispb: string;
	name: string;
	code: number;
	fullName: string;
}

@Component({
	selector: 'auto-complete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss'],
})
export class AutoCompleteComponent implements OnInit, OnChanges {
	search = 'fullName';
	data: IBank[] = banks.sort((a, b) => a.fullName.localeCompare(b.fullName));

	currentSearchValue: string;
	@Input() bankSelected: string;
	@Input() inputStatus: 'default' | 'error';
	@Output() selectedBank = new EventEmitter<IBank>();
	@ViewChild('autoComplete') autoComplete;
	constructor(protected translate: TranslateService) {}

	ngOnInit() {
		if (!this.bankSelected) {
			this.bankSelected = '';
		}
		this.currentSearchValue = this.bankSelected;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.bankSelected) {
			if (changes.bankSelected.previousValue && !this.bankSelected) {
				this.currentSearchValue = this.bankSelected;
				this.autoComplete.select(this.bankSelected || '');
			}
		}
	}

	selectEvent(evt) {
		if (typeof evt !== 'string') {
			this.bankSelected = evt.fullName;
			this.currentSearchValue = evt.fullName;
			this.selectedBank.emit(evt);
		}
	}

	onClearBankSelected() {
		this.selectedBank.emit(undefined);
		this.bankSelected = '';
		this.currentSearchValue = '';
	}

	onCloseInput() {
		if (this.currentSearchValue !== this.bankSelected) {
			this.currentSearchValue = this.bankSelected || '';
			this.autoComplete.select(this.bankSelected || '');
		}
	}
}
